<gl-pro-modal (closeModal)="close()">
  <p>
    {{ 'welcome_pro_message' | translate }}
    <a pro-link [href]="generateInstructionLink()" target="_blank">{{ 'link' | translate }}</a>
  </p>
</gl-pro-modal>
